module.exports = __webpack_public_path__ + "static/media/apple-pay.20064a36.png";